// The server rejects duplicate species hits with a 400, so this key must match its case-insensitive
// comparison of the (CommonName, ScientificName) pair over trimmed, blank→null values.
const blankToNull = value => {
  const trimmed = (value ?? '').toString().trim()
  return trimmed.length > 0 ? trimmed : null
}

export function normalizeSpeciesHit (hit) {
  return {
    commonName: blankToNull(hit?.commonName),
    scientificName: blankToNull(hit?.scientificName)
  }
}

export function speciesHitKey (hit) {
  const { commonName, scientificName } = normalizeSpeciesHit(hit)
  return `${(commonName ?? '').toLowerCase()}|${(scientificName ?? '').toLowerCase()}`
}

export function dedupeSpeciesHits (hits) {
  const byKey = new Map()
  ;(hits ?? []).forEach(hit => {
    const key = speciesHitKey(hit)
    if (!byKey.has(key)) byKey.set(key, normalizeSpeciesHit(hit))
  })
  return [...byKey.values()]
}

function findDuplicateSpeciesHits (hits) {
  const seen = new Set()
  return (hits ?? []).filter(hit => {
    const key = speciesHitKey(hit)
    if (seen.has(key)) return true
    seen.add(key)
    return false
  })
}

export function duplicateSpeciesHitKeys (hits) {
  return new Set(findDuplicateSpeciesHits(hits).map(speciesHitKey))
}
